const purchaseSeriesListActionTypes = {
  API_CALL_START: "API_CALL_START",
  API_CALL_SUCCESS: "API_CALL_SUCCESS",
  API_CALL_FAILURE: "API_CALL_FAILURE",
}

export default purchaseSeriesListActionTypes
